import React from 'react';
import styles from "./App.module.scss"
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import TakePart from "./components/TakePart/TakePart";
import DirectSpeech from "./components/DirectSpeech/DirectSpeech";
import PurposeProject from "./components/PurposeProject/PurposeProject";
import Advantages from "./components/Advantages/Advantages";
import Conditions from "./components/Conditions/Conditions";


function App() {
    return (
        <div className={styles.layout}>
            <div className={`${styles.backgroundContainer} ${styles.loaderBackgroundContainer}`}>
                <div className={styles.contentContainer}>
                    <Header/>
                    <div className={styles.blockTakePart}>
                        <TakePart/>
                    </div>
                    <DirectSpeech/>
                </div>
            </div>

            <div className={`${styles.contentContainer} ${styles.informationBlock}`}>
                <PurposeProject/>
                <Advantages/>
                <Conditions/>
            </div>
            <div className={`${styles.backgroundSmall} ${styles.loaderBackgroundSmall}`}>
                <div className={`${styles.contentContainer} `}>
                    <Footer/>
                </div>
            </div>
        </div>
    );
}

export default App;